import { Link } from "react-router-dom";
import { Check, X, ArrowRight } from "lucide-react";
import useReveal from "../shared/useReveal";
import "./CompareTable.css";
import "./HomeSections.css";

const ROWS = [
  { feature: "Goal planning", diy: false, pm: true },
  { feature: "Human advisor (CFA-led)", diy: false, pm: true },
  { feature: "Portfolio review & rebalancing", diy: false, pm: true },
  { feature: "Business finance", diy: false, pm: true },
  { feature: "Tax & compliance", diy: false, pm: true },
  { feature: "Insurance advice", diy: false, pm: true },
  { feature: "Quarterly reviews", diy: false, pm: true },
  { feature: "Buy / sell execution", diy: true, pm: true },
];

export default function CompareTable() {
  const ref = useReveal();

  return (
    <section className="section alt home-compare-section" id="why-poonji">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head home-compare-head pm-reveal">
          <span className="kicker">The Poonji Mitra Difference</span>
          <h2>DIY apps execute orders. We manage outcomes.</h2>
          <p className="sub">
            Discount platforms are great at buttons. When it comes to what to
            buy, when to rebalance, how to save tax — you&apos;re on your own.
            That&apos;s where we come in.
          </p>
        </div>

        <div className="home-compare-layout pm-reveal">
          <article className="home-compare-card home-compare-card--diy">
            <header>
              <span className="home-compare-tag">Self-directed</span>
              <h3>DIY Apps</h3>
              <p>Execution tools. You decide everything else.</p>
            </header>
            <ul>
              {ROWS.map((row) => (
                <li key={row.feature} className={row.diy ? "is-yes" : "is-no"}>
                  <span className="home-compare-icon" aria-hidden>
                    {row.diy ? <Check size={14} strokeWidth={3} /> : <X size={14} strokeWidth={3} />}
                  </span>
                  <span>{row.feature}</span>
                </li>
              ))}
            </ul>
          </article>

          <div className="home-compare-vs" aria-hidden>
            <span>VS</span>
          </div>

          <article className="home-compare-card home-compare-card--pm">
            <header>
              <span className="home-compare-tag">Expert-led</span>
              <h3>Poonji Mitra</h3>
              <p>Outcomes managed end-to-end by CFA · CA · CS.</p>
            </header>
            <ul>
              {ROWS.map((row) => (
                <li key={row.feature} className={row.pm ? "is-yes" : "is-no"}>
                  <span className="home-compare-icon" aria-hidden>
                    {row.pm ? <Check size={14} strokeWidth={3} /> : <X size={14} strokeWidth={3} />}
                  </span>
                  <span>{row.feature}</span>
                </li>
              ))}
            </ul>
            <Link to="/contact" className="home-compare-cta">
              Book a free consultation
              <ArrowRight size={16} />
            </Link>
          </article>
        </div>
      </div>
    </section>
  );
}
